<template>
    <div class="box">
        <div class="box-left">
            <my-form
                v-model="form"
                autocomplete="off"
                label-width="80px"
                @submit="submitHandler"
            >
                <el-form-item
                    label="计算额"
                    prop="costlimit"
                    :rules="newRule('计算额', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.costlimit"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入计算额`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="设置行业"
                    prop="industryratio"
                    :rules="newRule('行业', 'required')"
                >
                    <el-select
                        v-model="form.industryratio"
                        @change="industryratioHandler"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.industryid"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="设置专业"
                    prop="professional"
                    :rules="newRule('专业', 'required')"
                >
                    <el-select
                        v-model="form.professional"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in professionalArr"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.ratio"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <span class="coefficient"
                    >专业调整系数：{{ form.professional }}</span
                >

                <el-form-item
                    label="阶段收费"
                    prop="charge"
                    :rules="newRule('收费内容', 'required')"
                >
                    <el-select
                        v-model="form.charge"
                        @change="chargeHandler"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in chargeArr"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.industryid"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <div class="professional-level">
                    <el-form-item
                        label="设置专业"
                        prop="professionalComplex"
                        :rules="newRule('专业', 'required')"
                        class="professional-level-box"
                    >
                        <el-select
                            v-model="form.professionalComplex"
                            @change="professionalComplexHandler"
                            placeholder="请选择"
                            class="select"
                        >
                            <el-option
                                v-for="item in professionalComplexArr"
                                :key="item.industryid"
                                :label="item.industryname"
                                :value="item.industryid"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item
                        label="复杂等级"
                        prop="levelId"
                        :rules="newRule('复杂等级', 'required')"
                        class="professional-level-box"
                    >
                        <el-select
                            v-model="form.levelId"
                            @change="levelHandler"
                            placeholder="请选择"
                            class="select"
                        >
                            <el-option
                                v-for="item in levelArr"
                                :key="item.industryid"
                                :label="item.industryname"
                                :value="item.industryid"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <span class="professional-level-num"
                    >复杂程度调整系数系数：{{ form.level }}</span
                >

                <span class="professional-level-num"
                    >附加调整系数：{{ form.addition }}（自动生成）</span
                >

              <el-form-item
                label="折扣"
                prop="discount"
                :rules="newRule('折扣', 'required')"
              >
                <el-input
                  class="login-input"
                  v-model="form.discount"
                  @change="discountHandler"
                  clearable
                  type="number"
                  min="0"
                  autocomplete="off"
                  :placeholder="`请输入折扣`"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>

                <template slot="btn" slot-scope="scope">
                  <div class="btn-login">
                    <el-button
                      type="primary"
                      @click="scope.submitHandler"
                    >
                      开始计算
                    </el-button>
                  </div>
                </template>
            </my-form>
        </div>

        <div class="box-right">
            <div class="computed-result">
              <div>折扣后收费：<span>{{ discountCost }}</span> 万元</div>
              <div>标准设计费：<span>{{ standardCost }}</span> 万元</div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                max-height="145"
            >
                <el-table-column prop="name" label="阶段" min-width="130">
                </el-table-column>
                <el-table-column prop="ratio" label="比例" width="130">
                    <template slot-scope="scope">
                        {{ scope.row.ratio / 100 }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="calculate"
                    label="金额：万元"
                    width="130"
                >
                    <template slot-scope="scope">
                        {{ scope.row.calculate || "0.00" }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                costlimit: "", //估价
                industryratio: "", //行业
                professional: "", //专业
                discount: 100, //折扣
                charge: "", //阶段收费
                professionalComplex: "", //专业(复杂)
                level: "", //复杂等级
                levelId: "", //复杂等级id
                addition: "", //附加调整系数
                percent1: "", //比例1
                percent2: "", //比例2
                percent3: "", //比例3
                percent4: "", //比例4
            },

            options: [], //行业选择数组
            professionalArr: [], //专业选择数组
            chargeArr: [], //阶段收费数组
            professionalComplexArr: [], //专业(复杂)数组
            levelArr: [], //复杂等级数组

            leavelAll: [], //所有复杂等级数组

            discountCost: "0", //折扣后费用
            standardCost: "0", //标准费用

            tableData: [],
        };
    },
    methods: {
        /**
         * 设计计算提交
         */
        submitHandler() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getCalculateData.json`,
                {
                    costlimit: this.form.costlimit,
                    addition: this.form.addition,
                    industryratio: this.form.professional,
                    complexityratio: this.form.level,
                    ext: this.form.charge,
                    discount: this.form.discount,
                    percent1: this.form.percent1,
                    percent2: this.form.percent2,
                    percent3: this.form.percent3,
                    percent4: this.form.percent4,
                    type: "TYPE2",
                },
                (data) => {
                    this.discountCost = data.discount;
                    this.standardCost = data.standard;
                    this.tableData = data.table
                }
            );
            this.$emit('startCompute');
        },
        /**
         * 折扣输入框 change 事件
         */
        discountHandler() {
            if (this.form.discount < 0) {
                this.form.discount = 0;
            }
          let discountStr = String(this.form.discount)
          discountStr = discountStr.replace(/[^\d.]/g, "")
            .replace(/^0\d+|^\./g, "")
            .replace(/\.{2,}/g, ".")
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
          this.form.discount = parseFloat(discountStr) || 0;
        },
        /**
         * 行业选择框 change 事件
         */
        industryratioHandler() {
            // console.log("行业选择框 change 事件");
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getDesignAll.json`,
                {
                    id: this.form.industryratio,
                },
                (data) => {
                    // 数组 初始化
                    this.options = data.select1;
                    this.professionalArr = data.select2;
                    this.chargeArr = data.select3;
                    this.professionalComplexArr = data.select4;
                    this.levelArr = data.select5;
                    // 默认选中项 初始化
                    this.form.professional = data.select2[0].ratio;
                    this.form.charge = data.select3[0].industryid;
                    this.form.professionalComplex = data.select4[0].industryid;
                    this.form.level = data.select5[0].ratio;
                    this.form.levelId = data.select5[0].industryid;
                    this.form.addition = data.select5[0].addition;
                    this.form.percent1 = data.select3[0].percent1;
                    this.form.percent2 = data.select3[0].percent2;
                    this.form.percent3 = data.select3[0].percent3;
                    this.form.percent4 = data.select3[0].percent4;

                    this.professionalComplexHandler();
                    this.chargeHandler();
                }
            );
        },
        /**
         * 阶段收费选择框 change 事件
         */
        chargeHandler() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getStage.json`,
                {
                    id: this.form.charge,
                },
                (data) => {
                    this.tableData = data.stages.filter(function(val){
                        return val.ratio != "0"
                    });
                    this.form.percent1 = data.stages[0].ratio;
                    this.form.percent2 = data.stages[1].ratio;
                    this.form.percent3 = "";
                    this.form.percent4 = "";
                    if(data.stages.length > 2){
                        this.form.percent3 = data.stages[2].ratio;
                    }
                    if(data.stages.length > 3){
                        this.form.percent4 = data.stages[3].ratio;
                    }
                }
            );
        },
        /**
         * 设置专业(复杂)选择框 change 事件
         */
        professionalComplexHandler() {
            const that = this;
            that.levelArr = that.leavelAll.filter(function (val) {
                return val.parentid == that.form.professionalComplex;
            });
            that.form.levelId = that.levelArr[0].industryid;
            that.form.addition = that.levelArr[0].addition;
        },
        /**
         * 复杂等级选择框 change 事件
         */
        levelHandler() {
            const that = this;
            if (that.form.levelId) {
                var arr = that.levelArr.filter(function (val) {
                    return val.industryid == that.form.levelId;
                })[0];
                that.form.level = arr.ratio;
                that.form.addition = arr.addition;
            } else {
                that.form.level = "";
            }
        },
        /**
         * 获取首次数据
         */
        queryFirstData() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/firstShow.json`,
                (data) => {
                    // 数组 初始化
                    this.options = data.select1;
                    this.professionalArr = data.select2;
                    this.chargeArr = data.select3;
                    this.professionalComplexArr = data.select4;
                    this.levelArr = data.select5;
                    this.tableData = data.select6;
                    // 默认选中项 初始化
                    this.form.industryratio = data.select1[0].industryid;
                    this.form.professional = data.select2[0].ratio;
                    this.form.charge = data.select3[0].industryid;
                    this.form.professionalComplex = data.select4[0].industryid;
                    this.form.level = data.select5[0].ratio;
                    this.form.levelId = data.select5[0].industryid;
                    this.form.addition = data.select5[0].addition;
                    this.form.percent1 = data.select3[0].percent1;
                    this.form.percent2 = data.select3[0].percent2;
                    this.form.percent3 = data.select3[0].percent3;
                    this.form.percent4 = data.select3[0].percent4;
                }
            );
        },
        /**
         *  获取 复杂等级 数组(所有)
         */
        getDesignAll() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getDesignAll.json`,
                (data) => {
                    this.leavelAll = data.select5;
                }
            );
        },
    },
    mounted() {
        this.queryFirstData();
        this.getDesignAll();
    },
};
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    .coefficient {
        display: block;
        margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 24px;
        color: #606266;
    }
    .select {
        width: 100%;
    }
    .discount {
        position: absolute;
        left: 451px;
        top: 0px;
        width: 400px;
    }
    .btn-login {
      display: flex;
      justify-content: center;
    }
    .professional-level {
        width: 100%;
        height: 32px;
    }
    .professional-level-box {
        float: left;
        width: 200px;
        margin-bottom: 10px;
        // height: 40px;
    }
    .professional-level-num {
        display: block;
        // margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 10px;
        color: #606266;
    }
}
.box > div {
    float: left;
    width: 400px;
}

.box-right {
    margin-left: 100px;
    margin-bottom: 24px;
    width: 520px !important;
    margin-top: 0;
    .box-right-cost {
        margin-bottom: 20px;
    }
}

.computed-result{
  margin-top: -55px;
  font-size: 17px;
  font-weight: 600;
  color: #606266;
  div{
    margin-bottom: 15px;
  }
  span{
    color: red;
  }
}
</style>
